import { UseFormRegisterReturn } from "react-hook-form";

import { useTranslation } from "react-i18next";

import { useCallback } from "react";

import { ReactComponent as ImportantIcon } from "@assets/icons/to-do/important.svg?react";
import { ReactComponent as VeryImportantIcon } from "@assets/icons/to-do/very-important.svg?react";

import { SvgIcon } from "@/components/Icon/SvgIcon";

import { ERROR_TYPE, translateError } from "@/utils";

import { ToDoType } from "../../../ToDoList/enum/ToDoType.enum";
import { ToDoPriority } from "../../../ToDoList/enum/ToDoPriority.enum";

interface TypeRadioGroupProps {
	formRegister?: UseFormRegisterReturn;
	className: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	options: any[];
	errorMessage?: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	value?: any;
	needIcon?: boolean;
}

export default function TypeRadioGroup({
	options,
	className,
	formRegister,
	errorMessage,
	value,
	needIcon = true,
}: TypeRadioGroupProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-to-dos.${key}`);
	const getIcon = useCallback((type: ToDoType | ToDoPriority) => {
		switch (type) {
			case ToDoType.IMPORTANT:
				return ImportantIcon;
			case ToDoType.VERY_IMPORTANT:
				return VeryImportantIcon;
			default:
				return ImportantIcon;
		}
	}, []);

	return (
		<div className={`flex gap-2 w-full relative ${className}`}>
			{options.map((option) => (
				<div
					key={option}
					className="rounded-lg p-2 border w-fit flex items-center justify-center gap-2 cursor-pointer"
					style={{ borderColor: value === option ? "#B8431A" : "#DCDAD6" }}
				>
					<input
						{...formRegister}
						checked={value === option}
						className="peer hidden"
						id={option}
						type="radio"
						value={option}
					/>
					<label
						className="flex items-center gap-2 cursor-pointer relative before:w-4 before:h-4 before:rounded-full before:border before:border-gray-400 before:block before:content-[''] peer-checked:before:border-primary-blue peer-checked:before:bg-white peer-checked:before:ring-[1px] peer-checked:before:ring-primary-blue peer-checked:after:content-[''] peer-checked:after:w-[10px] peer-checked:after:h-[10px] peer-checked:after:rounded-full peer-checked:after:absolute peer-checked:after:left-[3px] peer-checked:after:top-[50%] peer-checked:after:-translate-y-1/2 peer-checked:after:block peer-checked:after:bg-primary-blue"
						htmlFor={option}
					>
						<p
							className="flex text-[14px] items-center font-medium leading-5"
							style={{ color: value === option ? "#B8431A" : "#686761" }}
						>
							{needIcon && (
								<SvgIcon
									className={`w-4 h-4 ${value === option ? "fill-primary-blue" : "fill-muted"}`}
									svgIcon={getIcon(option)}
								/>
							)}
							{ts(option)}
						</p>
					</label>
				</div>
			))}
			{errorMessage && (
				<p className="absolute -bottom-5 text-[12px] text-danger">
					{translateError[errorMessage as unknown as ERROR_TYPE] ?? errorMessage}
				</p>
			)}
		</div>
	);
}
